<ul class="taps-section" role="tablist">
  <li *ngFor="let item of tabs" role="none">
    <a *hasPermission="item.slug" class="tap" [routerLink]="[item.route]" routerLinkActive="active-tap" role="tab">
      {{ item.name }}
    </a>
  </li>
</ul>
